import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import { OptionExercise, OptionExerciseForm } from "./optionExerciseDomain";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<OptionExercise>,
  data?: OptionExercise,
): OptionExerciseForm {
  return new OptionExerciseForm(dispatch, context, data);
}

export function initForm(form: OptionExerciseForm): undefined {
  form.programs.forEach((program) => form.loadHoldingCompanies(program.planId));
  return undefined;
}

export function isValid(form: OptionExerciseForm): boolean {
  return form.isValid;
}

export function validate(form: OptionExerciseForm): boolean {
  return form.validate();
}

export function applyForm(form: OptionExerciseForm): OptionExercise {
  return form.toData();
}

export const optionExerciseHandler: DecisionTypeHandler<
  DecisionType.optionExercise,
  OptionExercise,
  OptionExerciseForm
> = {
  type: DecisionType.optionExercise,
  initNewForm,
  initForm,
  isValid,
  validate,
  applyForm,
};
